import React, {Fragment, memo} from 'react';
import {FormattedDate, FormattedTime} from 'react-intl';

import Link from '../link';

import style from './event-mini.module.scss';

export default memo(
	/**
	 * @param {{
	 *   event: import("../../utils/events").EventMini,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function Event({event: {id, date, title, description}}) {
		return (
			<div className={style.base}>
				<Link
					href={`#${id}`}
					className={style.link}
				>
					<time
						className={style.date}
						dateTime={date.date.toISOString()}
					>
						<FormattedDate
							value={date.date}
							timeZone="Europe/Berlin"
							weekday="short"
							month="short"
							day="2-digit"
						/>

						{date.hasTime && (
							<Fragment>
								{' - '}
								<FormattedTime
									value={date.date}
									timeZone="Europe/Berlin"
									hour="2-digit"
									minute="2-digit"
								/>
							</Fragment>
						)}
					</time>

					<h2 className={style.title}>
						{title}
					</h2>

					<p className={style.description}>
						{description}
					</p>
				</Link>
			</div>
		);
	}
);
